import Axios from 'axios'
import {facilityDiscountTypeUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_facility_discount_types (context) {
    Axios.get(facilityDiscountTypeUrls.getAllFacilityDiscountTypes).then(function (response) {
      context.commit('GET_ALL_DISCOUNT_TYPES', response.data)
    })
  },
  get_facility_discount_types (context, publicId) {
    Axios.get(facilityDiscountTypeUrls.getFacilityDiscountTypes + publicId).then(function (response) {
      context.commit('GET_DISCOUNT_TYPES', response.data)
    })
  },
  get_deleted_facility_discount_types (context) {
    Axios.get(facilityDiscountTypeUrls.getDeletedFacilityDiscountType).then(function (response) {
      context.commit('GET_DELETED_DISCOUNT_TYPES', response.data)
    })
  },
  get_facility_discount_type (context, publicId) {
    Axios.get(facilityDiscountTypeUrls.getFacilityDiscountType + publicId).then(function (response) {
      context.commit('GET_DISCOUNT_TYPE', response.data)
    })
  },
  post_facility_discount_type (context, data) {
    Axios.post(facilityDiscountTypeUrls.postFacilityDiscountType, data).then(function () {
      context.dispatch('get_all_facility_discount_types')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  update_facility_discount_type (context, data) {
    Axios.post(facilityDiscountTypeUrls.editFacilityDiscountType, data).then(function () {
      context.dispatch('get_all_facility_discount_types')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_facility_discount_type (context, publicId) {
    Axios.get(facilityDiscountTypeUrls.deleteFacilityDiscountType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_DISCOUNT_TYPES', response.data)
      router.push({
        name: 'Module.DeletedFacilityDiscountTypes'
      })
    })
  },
  restoreFacilityDiscountType (context, publicId) {
    Axios.get(facilityDiscountTypeUrls.restoreFacilityDiscountType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_DISCOUNT_TYPES', response.data)
      router.push({
        name: 'Module.FacilityDiscountTypes'
      })
    })
  }
}
